/**
 * Handles scrolling effect
 * @module fixedScroll
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'fixedScroll';
export const SCROLL_EVENT = 'scroll';
export const FS_FIXED_CLASS = 'fixed-scroll';
export const FS_ABSOLUTE_CLASS = 'absolute-scroll';

export const DEFAULTS = {

};
/**
 * Handle Scroll Event
 * @param  {jQuery} $el - scroll Element
 */
const scrollEventHandler = ($el) => {
  $(window).on(SCROLL_EVENT, () => {
    const scroll = $(window).scrollTop();
    const stickyHeight = $el.outerHeight(true);
    const $stickyParent = $el.parent();
    const stickyParentHeight = $stickyParent.outerHeight(true);
    const stickyTopGap = parseInt($stickyParent.css('paddingTop'), 10) + 4; // 4 is due to line height in text
    const stickyBottomGap = stickyParentHeight - stickyHeight;

    if (stickyTopGap < scroll && scroll < stickyBottomGap) {
      $el.removeClass(FS_ABSOLUTE_CLASS).addClass(FS_FIXED_CLASS);
    } else if (scroll > stickyBottomGap) {
      $el.removeClass(FS_FIXED_CLASS).addClass(FS_ABSOLUTE_CLASS);
    } else {
      $el.removeClass(`${FS_FIXED_CLASS} ${FS_ABSOLUTE_CLASS}`);
    }
  });
};
/**
 * Set Event setEventListeners
 * @param  {jQuery} $el - dropdown wrap
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const applyEventHandlers = ($el, opts = {}) => {
  scrollEventHandler($el, opts);
};
/**
 * Initializes Fixed Scroll.
 * @param {HTMLElement} el - scroll Element
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function fixedScroll(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
}
// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, fixedScroll);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/fixed-scroll.js